import { Provider } from '@angular/core';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogConfig,
} from '@angular/material/dialog';

/**
 * Material M3 dialog defaults for Payee.
 *
 * Spread `MatDialogConfig` so built-in defaults (backdrop, etc.) are kept.
 * `panelClass: 'payee-dialog'` sizes the Material shell (see payee-theme.scss).
 * Card chrome is painted by `payee-popup`, not the Material surface.
 *
 * @see https://v21.material.angular.dev/components/dialog/overview
 */
export function providePayeeDialog(): Provider[] {
  return [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'payee-dialog',
        autoFocus: 'first-tabbable',
        maxWidth: '90vw',
        maxHeight: '90vh',
      } satisfies MatDialogConfig,
    },
  ];
}
